module.exports = __webpack_public_path__ + "static/media/title_bg_11.7d4067dd.png";